import React from "react";
import {
  GOVGR_HEADER_LINK,
  GOVGR_HEADER_LOGO,
  GOVGR_HEADER_TITLE,
} from "../../conf/styles/GovGrDrawerMenu";

const HeaderContent = ({ apptitle, hamburgermenu }) => {
  return (
    <div className={`flex xs:flex-col md:flex-row md:w-[65vh]`}>
      <div className="xs:flex xs:w-[80vw] xs:justify-between md:flex-none md:w-[40%]">
        <a
          href="https://www.gov.gr/"
          className={`${GOVGR_HEADER_LINK} xs:flex xs:justify-center xs:w-full md:flex-none`}
        >
          <img
            src="https://www.gov.gr/gov_gr_logo.svg"
            className={GOVGR_HEADER_LOGO}
            alt="GovGr_Header_Logo"
          />
        </a>
        {hamburgermenu}
      </div>
      <a href="/" className={`${GOVGR_HEADER_TITLE} text-center`}>
        {apptitle}
      </a>
    </div>
  );
};

export default HeaderContent;
